import React, { useEffect, useRef, useState } from 'react';
import { ref, set, get } from 'firebase/database';
import { database } from '../firebase/config';

const LoadingScreen = ({ progress }) => {
  const hasIncremented = useRef(false);
  const progressBarRef = useRef(null);
  const [currentStatus, setCurrentStatus] = useState('Initializing...');

  // Update status based on progress
  useEffect(() => {
    const getStatusText = (progress) => {
      if (progress <= 16) return 'Loading recent data...';
      if (progress <= 33) return 'Fetching trending movies...';
      if (progress <= 50) return 'Getting Netflix Philippines Top 10...';
      if (progress <= 66) return 'Fetching Korean dramas...';
      if (progress <= 83) return 'Loading anime collection...';
      if (progress < 100) return 'Finalizing data...';
      return 'Ready to stream!';
    };

    const newStatus = getStatusText(progress);
    if (newStatus !== currentStatus) {
      setCurrentStatus(newStatus);
    }
  }, [progress, currentStatus]);

  // Firebase view count - moved to separate effect and optimized
  useEffect(() => {
    if (hasIncremented.current) return;
    hasIncremented.current = true;

    // Don't await this to prevent blocking
    const handleViewCount = async () => {
      try {
        const countRef = ref(database, 'viewCount/count');
        const snapshot = await get(countRef);
        
        if (!snapshot.exists()) {
          await set(countRef, 1);
        } else {
          await set(countRef, snapshot.val() + 1);
        }
      } catch (error) {
        console.error('Error updating view count:', error);
      }
    };

    // Run without waiting for completion
    handleViewCount();
  }, []);

  // Optimize progress bar updates with requestAnimationFrame
  useEffect(() => {
    if (progressBarRef.current) {
      // Use requestAnimationFrame for smooth updates
      requestAnimationFrame(() => {
        progressBarRef.current.style.width = `${progress}%`;
      });
    }
  }, [progress]);

  return (
    <div className="fixed inset-0 bg-black flex flex-col items-center justify-center z-50">
   

      {/* Main Loading Text */}
      <div className="text-white text-2xl mb-2 font-semibold text-center">
        Loading, Please support my funds...
      </div>
      <div className="text-gray-400 text-sm mb-8">
        version 2.6
      </div>

      {/* Current Status */}
      <div className="text-red-400 text-lg mb-2 font-medium animate-pulse">
        {currentStatus}
      </div>

      {/* Progress Percentage */}
      <div className="text-gray-400 text-sm mb-8">
        {progress}% Complete
      </div>



      {/* Loading Steps Indicator */}
      <div className="flex space-x-2">
        {[
          { label: 'Recent', threshold: 16 },
          { label: 'Movies', threshold: 33 },
          { label: 'Top 10', threshold: 50 },
          { label: 'K-Drama', threshold: 66 },
          { label: 'Anime', threshold: 83 },
          { label: 'Done', threshold: 100 }
        ].map((step, index) => (
          <div key={index} className="flex flex-col items-center">
            <div 
              className={`w-3 h-3 rounded-full border-2 transition-all duration-300 ${
                progress >= step.threshold 
                  ? 'bg-red-600 border-red-600' 
                  : progress >= step.threshold - 16
                    ? 'border-red-400 bg-red-400/30 animate-pulse'
                    : 'border-gray-600 bg-gray-800'
              }`}
            />
            <span className={`text-xs mt-1 transition-colors duration-300 ${
              progress >= step.threshold 
                ? 'text-red-400' 
                : 'text-gray-600'
            }`}>
              {step.label}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LoadingScreen;


